module.exports = __webpack_public_path__ + "media/swainsons-thrush-1.08921db8.mp3";